import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { I18nProvider } from './i18n/index.tsx'
import { ThemeProvider } from './theme/ThemeProvider.tsx'
import { toolEn } from './i18n/tool-en.ts'
import { toolZh } from './i18n/tool-zh.ts'
import './index.css'

const toolTranslations = { en: toolEn, zh: toolZh }

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <I18nProvider toolTranslations={toolTranslations}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </I18nProvider>
  </React.StrictMode>,
)
